import { generatePath, useParams } from "react-router-dom";

import {
  AudioQuestionData,
  CompletedAudioAnswer,
  ConsultationAudioAnswer,
} from "~/common/utils/consultations/shared";
import { screeningAudioPath } from "~/patients/api";
import { ConsultationAudioForm } from "~/patients/components/consultations";
import {
  useDeleteConsultationAudioS3,
  useGetCurrentPatient,
  useUploadConsultationAudioS3,
} from "~/patients/hooks";

export interface ScreeningAudioFormProps {
  question: AudioQuestionData;
  handleGoBack: () => void;
  onSubmit: (answer: ConsultationAudioAnswer) => void;
  isSubmitting: boolean;
  disableBack: boolean;
  completedAnswer?: CompletedAudioAnswer;
  isOptional: boolean;
}

export const ScreeningAudioForm = ({
  question,
  handleGoBack,
  onSubmit,
  isSubmitting,
  completedAnswer,
  disableBack,
  isOptional,
}: ScreeningAudioFormProps) => {
  const { id: patientScreeningId } = useParams();

  const { data: patient } = useGetCurrentPatient();
  const consultationId = patient?.consultation?.id;

  const basePath = generatePath(screeningAudioPath, {
    consultationId: consultationId ?? "",
    patientId: patientScreeningId ?? "",
  });

  const { handleUploadAudio, pendingUploadAudio } =
    useUploadConsultationAudioS3(basePath);

  const { deleteAudioMutation, pendingDeleteAudio } =
    useDeleteConsultationAudioS3(basePath);

  return (
    <ConsultationAudioForm
      question={question}
      handleGoBack={handleGoBack}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      completedAnswer={completedAnswer}
      disableBack={disableBack}
      handleUploadAudio={handleUploadAudio}
      pendingUploadAudio={pendingUploadAudio}
      deleteAudioMutation={deleteAudioMutation}
      pendingDeleteAudio={pendingDeleteAudio}
      isOptional={isOptional}
    />
  );
};
